<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
        <b-breadcrumb :items="items" v-if="thai_student==1" />
        <b-breadcrumb :items="items_eng" v-if="thai_student==0" />
      </div>
      <create-bio></create-bio>
      <create-employment></create-employment>
      <create-employment1></create-employment1>
<!--      <create-employment2></create-employment2>-->
    </div>
  </div>
</template>

<script>
import CreateEmployment from "../../components/CreateEmployment.vue";
import CreateEmployment1 from "../../components/CreateEmployment1.vue";
import CreateEmployment2 from "../../components/CreateEmployment2.vue";
import CreateBio from "../../components/CreateBio.vue";
export default {
  components: {
    CreateEmployment,
    CreateEmployment1,
    CreateEmployment2,
    CreateBio
  },
  name: "Employment",
  data() {
    return {
      items: [
        {
          text: "หน้าหลัก",
          href: "#/main"
        },
        {
          text: "ภาวะการมีงานทำ",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/main"
        },
        {
          text: "Employment Survey",
          href: "#"
        }
      ],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {
    this.thai_student = this.$store.state.user.thaistudent;
  }
};
</script>
<style></style>
